import { TableSorting, useTableSort } from '@/shared/hooks/useTableSort';
import { ColumnDef, TableV2, TableV2Props } from './TableV2';

export type SortableColumnDef<T> = {
  sortable?: boolean;
} & ColumnDef<T>;

type SortableTableProps<T> = {
  columns: SortableColumnDef<T>[];
  rowSort?: boolean;
  onSort?: (sorts: TableSorting<T>[]) => void;
} & TableV2Props<T>;

export const SortableTable = <T,>({
  columns,
  rowSort,
  onSort,
  ...tableProps
}: SortableTableProps<T>) => {
  const { rows, columns: sortableColumns } = useTableSort({
    rows: tableProps.rows,
    columns,
    rowSort,
    onSort,
  });

  return <TableV2<T> {...tableProps} columns={sortableColumns} rows={rows} />;
};
